import React from 'react';
import AdvertisementBanner from './AdvertisementBanner';

/**
 * Renders advertisement based on template type and variant
 * Extensible for future variant types (modal, card, etc.)
 */
const AdvertisementRenderer = ({ advertisement, onDismiss, variant = 'banner' }) => {
  if (!advertisement) return null;

  // Currently only banner variant is implemented
  // Future variants could include 'modal', 'card', 'inline', etc.
  switch (variant) {
    case 'banner':
    default:
      return (
        <AdvertisementBanner
          advertisement={advertisement}
          onDismiss={onDismiss}
          variant={variant}
        />
      );
  }
};

export default AdvertisementRenderer;
